<script setup lang="ts">
import { useAttrs } from 'vue';
import useADialog from './useADialog';

const attrs = useAttrs();
const { activeModal, activeModalProps, dialogVisibility, styles } = useADialog();

function resetModalState() {
  activeModal.value = '';
  activeModalProps.value = null;
  styles.value = ['w-full sm:w-[600px]'];
}
</script>

<template>
  <Dialog
    v-bind="attrs"
    v-model:visible="dialogVisibility"
    modal
    pt:content="overflow-hidden pb-[74px]"
    pt:header="justify-end"
    :class="['relative mx-4 max-h-full sm:max-h-[95vh]', ...styles]"
    @after-hide="resetModalState"
  >
    <slot />
  </Dialog>
</template>
